import { cn } from "../../lib/utils"
import { Button } from "../../components/ui/Button"
import { Input } from "../../components/ui/Input"
import { Label } from "../../components/ui/Label"
import { Github } from "lucide-react"
// import type React from "react" // Import React

export function LoginForm({ className, setUser, user, password, setPassword, onSubmit, userRef, errRef, errMsg, ...props }) {
  return (
    <div className="w-full max-w-sm space-y-8">
      <div className="space-y-2">
        <h1 className="text-[24px] font-semibold tracking-tight">Login to your account</h1>
        <p className="text-[14px] text-muted-foreground">Enter your credentials below to login to your account</p>
      </div>
      <form onSubmit={onSubmit} className={cn("space-y-4", className)} {...props}>
        <div className="space-y-2">
          <Label htmlFor="email" className="text-[14px]">
            Username
          </Label>
          <Input
            id="email"
            placeholder="Username"
            required
            ref={userRef}
            autoComplete="off"
            onChange={(e) => setUser(e.target.value)}
            value={user}
            className="h-10 border-gray-200"
          />
        </div>
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-[14px]">
              Password
            </Label>
            {/* <a href="#" className="text-[14px] text-gray-500 hover:text-gray-800">
              Forgot your password?
            </a> */}
          </div>
          <Input
            id="password"
            type="password"
            required
            autoComplete="off"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            className="h-10 border-gray-200"
          />
        </div>
        <div className="flex justify-center">
          <p ref={errRef} className="text-sm py-2 text-red-600">
            {typeof errMsg === "object" ? (errMsg?.message || JSON.stringify(errMsg)) : String(errMsg || "")}
          </p>
        </div>
        <Button type="submit" className="w-full bg-black text-white hover:bg-gray-800">
          Login
        </Button>
      </form>

      {/* <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-white px-2 text-muted-foreground">Or continue with</span>
        </div>
      </div>

      <Button variant="outline" className="w-full border-gray-200 hover:bg-gray-50">
        <Github className="mr-2 h-4 w-4" />
        Login with GitHub
      </Button>

      <div className="text-center text-sm text-gray-500">
        Don't have an account?{" "}
        <a href="#" className="text-black hover:underline">
          Sign up
        </a>
      </div> */}
    </div>
  )
}

